import { z } from '@harvestiq/zod';
import {
  dbClaimDocumentInsertSchema,
  dbClaimDocumentSchema,
} from './db-claim-documents';

export const updateClaimDocumentReqParamsSchema = z.object({
  claimDocumentId: z.string().uuid(),
});

export const updateClaimDocumentReqBodySchema =
  dbClaimDocumentInsertSchema.pick({
    uploadStatus: true,
    uploadedAt: true,
  });
export type UpdateClaimDocumentReqBody = z.infer<
  typeof updateClaimDocumentReqBodySchema
>;

export const updateClaimDocumentResponseSchema = z.object({
  claimDocument: dbClaimDocumentSchema.optional(),
  error: z.string().optional(),
});
export type UpdateClaimDocumentResponse = z.infer<
  typeof updateClaimDocumentResponseSchema
>;
